/**
 * AuthLayout — centred card frame for signup, login, forgot-password,
 * and verify pages. No top nav; just the brand mark and the form card.
 */

import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { GiOrbitLogo } from '@/components/GiOrbitLogo';
import { Toaster } from '@/components/Toaster';

export function AuthLayout() {
  const { t } = useTranslation('auth');
  return (
    <div className="flex min-h-screen flex-col bg-canvas text-ink">
      <header className="border-b border-border bg-surface/70">
        <div className="mx-auto flex h-14 w-full max-w-6xl items-center px-4 sm:px-6">
          <a
            href="https://growing-intelligence.com"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 rounded-md px-1 py-1 hover:bg-surface-raised"
          >
            <GiOrbitLogo size="sm" />
            <span className="text-sm font-semibold tracking-tight">Growing Intelligence</span>
          </a>
        </div>
      </header>

      <main id="main" className="flex flex-1 items-center justify-center px-4 py-10 sm:py-16">
        <div className="w-full max-w-md">
          <div className="mb-6 text-center">
            <h1 className="text-2xl font-semibold tracking-tight">{t('welcome.title')}</h1>
            <p className="mt-1 text-sm text-ink-muted">{t('welcome.tagline')}</p>
          </div>
          <div className="rounded-xl border border-border bg-surface p-6 shadow-raised sm:p-8">
            <Outlet />
          </div>
        </div>
      </main>

      <Toaster />
    </div>
  );
}
